import { Injectable, Type } from '@angular/core';

import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { BetGeneratorModule } from './bet-generator.module';

@Injectable({ providedIn: 'root' })
export class BetGeneratorLoaderService extends ComponentLoaderService<BetGeneratorModule> {
    moduleName = 'BetGeneratorModule';

    constructor(moduleLoader: ModuleLoaderService, loggerFactory: LoggerFactory) {
        super(moduleLoader, loggerFactory);
    }

    getGeneratorColumnComponent(): ComponentProxy {
        return this.getComponentProxy((module) => module.columnComponent, 'betgenerator');
    }

    getGeneratorModalComponent(): ComponentProxy {
        return this.getComponentProxy((module) => module.modalComponent, 'betgenerator');
    }

    getModule(): Promise<Type<BetGeneratorModule>> {
        return import('./bet-generator.module').then((m) => m.BetGeneratorModule);
    }
}
